<sc-padding>
    <sc-flex>
        <div class="label">{{station?.name}}</div>
        <sc-content-spacer grow></sc-content-spacer>
        <sc-icon iconClass="fa-magnifying-glass" (click)="clickSearch()"></sc-icon>
    </sc-flex>
</sc-padding>
